import React from "react";

export default function Business() {
  return (
    <div className="home-root">
      <div style={{ maxWidth: 980, margin: "40px auto", padding: 28 }}>
        <h1>Business</h1>
        <p className="muted">Under construction — B2B offerings and contact info coming soon.</p>
      </div>
    </div>
  );
}